export interface BadgeProps {
  children: React.ReactNode;
  variant?: "default" | "success" | "warning" | "danger" | "info" | "muted";
  className?: string;
  onClick?: () => void;
}

const BASE = "inline-flex items-center px-2 py-0.5 rounded-[4px] text-[10px] font-semibold whitespace-nowrap tracking-[0.3px]";

const VARIANT_CLASS: Record<string, string> = {
  default: "bg-[var(--badge-muted-bg)] text-text2",
  success: "bg-green-500/[0.12] text-green",
  warning: "bg-yellow-500/[0.12] text-yellow",
  danger: "bg-red-500/[0.12] text-red",
  info: "bg-blue-500/[0.08] text-accent",
  muted: "bg-[var(--badge-muted-bg)] text-text2",
};

export function Badge({ children, variant = "default", className = "", onClick }: BadgeProps) {
  const cls = `${BASE} ${VARIANT_CLASS[variant] || VARIANT_CLASS.default} ${onClick ? "cursor-pointer" : ""} ${className}`.trim();

  return (
    <span
      className={cls}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      {children}
    </span>
  );
}

export function completionVariant(completion: string): BadgeProps["variant"] {
  switch (completion) {
    case "complete": return "success";
    case "partial": return "warning";
    case "incomplete": return "danger";
    case "missing_tests": return "muted";
    default: return "muted";
  }
}

export function completionLabel(completion: string): string {
  switch (completion) {
    case "complete": return "complete";
    case "partial": return "partial";
    case "incomplete": return "incomplete";
    case "missing_tests": return "no tests";
    default: return completion;
  }
}
